import { PATH_ROOT } from "@/constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useSchedulesReportBreadcrumb = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("reports.navigation.schedulesReport") },
    ],
    [t],
  );
};

export { useSchedulesReportBreadcrumb };
